import { render, staticRenderFns } from "./SliceAction.vue?vue&type=template&id=6f39bf20&scoped=true&"
import script from "./SliceAction.vue?vue&type=script&lang=js&"
export * from "./SliceAction.vue?vue&type=script&lang=js&"
import style0 from "./SliceAction.vue?vue&type=style&index=0&id=6f39bf20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f39bf20",
  null
  
)

export default component.exports